import type { SWRConfiguration } from 'swr';

export const swrGlobalConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  dedupingInterval: 10_000,
  focusThrottleInterval: 60_000,
  errorRetryCount: 1,
  errorRetryInterval: 5000,
};
